import { CarOperatorWarningApiDto, CompanyApiDto } from './dto';
import { apiRequest, BaseOptions, getBaseOptions } from './utils/util';

const rootPath = '/v2/car';

export const getCompaniesFromOrders = async (options?: BaseOptions) =>
  apiRequest<Array<CompanyApiDto>, void, void>({
    ...getBaseOptions(options),
    url: `${rootPath}/orders/companies`,
  });

export const openOperatorWarning = async (data: CarOperatorWarningApiDto, options?: BaseOptions) =>
  apiRequest<void, CarOperatorWarningApiDto, void>({
    ...getBaseOptions(options),
    data: data,
    method: 'POST',
    url: `${rootPath}/operator-warning`,
  });
